module.exports = __webpack_public_path__ + "static/media/14UNEP10.a4c7c351.jpg";